export default "__VITE_ASSET__DIJjqFE1__"